import { ApplicationRowSkeleton } from '@/components/ui/skeletons/application-row-skeleton';
import { ApplicationTileSkeleton } from '@/components/ui/skeletons/application-tile-skeleton';
import { AppViewMode } from '@/enums/app-view-mode.enums';
import {
  APP_ROW_SKELETON_COUNT,
  APP_TILE_SKELETON_COUNT,
  COLLECTION_CLASSES,
} from '@/features/applications/constants/applications.constants';
import type { UserApplication } from '@/types/api.types';
import { ApplicationRow } from './application-row';
import { ApplicationTile } from './application-tile';

export function AppSkeletonCollection({ viewMode }: { viewMode: AppViewMode }) {
  if (viewMode === AppViewMode.ICONS) {
    return (
      <div className={COLLECTION_CLASSES[viewMode]}>
        {Array.from({ length: APP_TILE_SKELETON_COUNT }, (_, index) => (
          <ApplicationTileSkeleton key={index} />
        ))}
      </div>
    );
  }

  return (
    <div className={COLLECTION_CLASSES[viewMode]}>
      {Array.from({ length: APP_ROW_SKELETON_COUNT }, (_, index) => (
        <ApplicationRowSkeleton key={index} layout={viewMode} />
      ))}
    </div>
  );
}

interface AppCollectionProps {
  apps: UserApplication[];
  viewMode: AppViewMode;
  onLaunch: (application: UserApplication) => void;
  loadingAppId?: string | null;
}

export function AppCollection({
  apps,
  viewMode,
  onLaunch,
  loadingAppId,
}: AppCollectionProps) {
  if (viewMode === AppViewMode.ICONS) {
    return (
      <div className={COLLECTION_CLASSES[viewMode]}>
        {apps.map(app => (
          <ApplicationTile
            key={app.app_id}
            application={app}
            onClick={onLaunch}
            isLoading={loadingAppId === app.app_id}
          />
        ))}
      </div>
    );
  }

  return (
    <div className={COLLECTION_CLASSES[viewMode]}>
      {apps.map(app => (
        <ApplicationRow
          key={app.app_id}
          application={app}
          layout={viewMode}
          onClick={onLaunch}
          isLoading={loadingAppId === app.app_id}
        />
      ))}
    </div>
  );
}
